<template>
  <div class="content-body">
    <AllNfts :pictureLink="pictureLink" projectname="Reaperville" />
  </div>
</template>

<script>
import AllNfts from "@/components/AllNfts.vue";

export default {
  name: "App",
  components: { AllNfts },

  data() {
    return {
      pictureLink: [
        "https://raw.githubusercontent.com/Surviville/Reaperville/master/png-low-res/",
        "https://raw.githubusercontent.com/Surviville/Reaperville/master/png/",
      ],
    };
  },
};
</script>
